// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.ejs styling */

html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

foundation-router {
  padding-top: 60px;
}

:not(:defined) {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/main/main.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* index.ejs styling */\n\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\n\nfoundation-router {\n  padding-top: 60px;\n}\n\n:not(:defined) {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
